<div class="skeleton-loader chart" [ngClass]="{'stacked-chart': isStacked === true, 'even-odd-color-scheme': evenOddColorScheme === true}">
    <div class='axes'>
        <div class="independent-axis" 
        [ngClass]="{'x-axis': dependentAxis === 'y-axis', 'y-axis': dependentAxis === 'x-axis', 'hide-grid-lines': !shouldShowIndependentAxisTickMarks}">
            <div class="dependent-axis pulse" [ngClass]="{'y-axis': dependentAxis === 'y-axis', 'x-axis': dependentAxis === 'x-axis'}">
                <div class="data-dependent-ticks pulse">
                    @if (tickMarksCountArray.length > 0) {
                        <div class="grid-line"></div>
                    }
                    @for( i of tickMarksCountArray; track i) {
                        <div class="grid-line"></div>
                    }
                </div>
            </div>
            
            <div class="bar-wrapper" *ngIf="barCount > 0">
                <div class="bar" [ngStyle]="{'--length': dataset[0], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 1">
                <div class="bar" [ngStyle]="{'--length': dataset[1], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 2">
                <div class="bar" [ngStyle]="{'--length': dataset[2], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 3">
                <div class="bar" [ngStyle]="{'--length': dataset[3], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 4">
                <div class="bar" [ngStyle]="{'--length': dataset[4], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 5">
                <div class="bar" [ngStyle]="{'--length': dataset[5], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 6">
                <div class="bar" [ngStyle]="{'--length': dataset[6], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 7">
                <div class="bar" [ngStyle]="{'--length': dataset[7], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 8">
                <div class="bar" [ngStyle]="{'--length': dataset[8], '--thickness': barThickness}"></div>
            </div>
            <div class="bar-wrapper" *ngIf="barCount > 9">
                <div class="bar" [ngStyle]="{'--length': dataset[9], '--thickness': barThickness}"></div>
            </div>
        </div>
    </div>
</div>
<div class="skeleton-loader legend" [ngClass]="{'even-odd-color-scheme': evenOddColorScheme === true}">
    <div class="legend-wrapper">
        @for (j of legendCountArray; track j) {
        <div class="legend-item-wrapper">
            <div class="legend-item"></div>
        </div>
        }
    </div>
</div>
